import type { PostMediaType } from '@/types/scheduler/post/media/mediaType';
import type { LibraryMediaType } from '@/utils/hooks/swr/useLibraryMedia/types/types';

import { TYPE_DOCUMENT, TYPE_GIF, TYPE_IMAGE, TYPE_VIDEO } from '@/lib/scheduler/postType';

export function formatLibraryMediaForPost(media: LibraryMediaType) {
    const libraryMedia = media.medias[0];
    let formattedMedia = {
        library_media_id: media?.id,
        id: libraryMedia.scheduler_media_id,
        scheduler_media_id: libraryMedia.scheduler_media_id,
        type: libraryMedia.type,
        original_media_id: libraryMedia.scheduler_media_id,
        original_medium_thumbnail: libraryMedia.medium_thumbnail,
        original_min_thumbnail: libraryMedia.min_thumbnail,
        min_thumbnail: libraryMedia.min_thumbnail,
        medium_thumbnail: libraryMedia.medium_thumbnail,
        file_info: libraryMedia.file_info
    } as PostMediaType;

    if (formattedMedia.type === TYPE_VIDEO && libraryMedia.type === TYPE_VIDEO) {
        formattedMedia = {
            ...formattedMedia,
            original: libraryMedia.video,
            video: libraryMedia.video,
            thumbnail: libraryMedia.thumbnail
        };
    }

    if (formattedMedia.type === TYPE_IMAGE && libraryMedia.type === TYPE_IMAGE) {
        formattedMedia = {
            ...formattedMedia,
            original: libraryMedia.image,
            image: libraryMedia.image
        };
    }

    if (formattedMedia.type === TYPE_GIF && libraryMedia.type === TYPE_GIF) {
        formattedMedia = {
            ...formattedMedia,
            original:
                libraryMedia.image || libraryMedia.min_thumbnail || libraryMedia.medium_thumbnail,
            image: libraryMedia.image || libraryMedia.min_thumbnail || libraryMedia.medium_thumbnail
        };
    }

    if (formattedMedia.type === TYPE_DOCUMENT && libraryMedia.type === TYPE_DOCUMENT) {
        formattedMedia = {
            ...formattedMedia,
            document: libraryMedia.document,
            original: libraryMedia.document,
            document_page1: libraryMedia.document_page1,
            document_page2: libraryMedia.document_page2
        };
    }

    return formattedMedia;
}
